
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CartItemType } from "@/types/cart-item";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";

const { State } = namespace("Root");

@Component
export default class CartCategoryMobile extends Vue {
  @State("cart") cart!: Cart;
  @Prop({ default: "unknown" })
  code!: string;
  @Prop()
  parentRefs!: any;

  component_class = "temp";
  observer: any;
  windowWidth = 732;

  mounted() {
    this.observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        switch (m.type) {
          case "attributes":
            this.$nextTick(() => {
              this.onClassChange((m.target as any).className);
            });
            break;
        }
      }
    });

    this.observer.observe(this.$refs.cat, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });

    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth, {
        passive: false,
      });
      this.getWindowWidth(null);
    });

    this.onNrItemsChange();
  }

  beforeDestroy() {
    document.removeEventListener("resize", this.getWindowWidth);
  }

  getWindowWidth(event) {
    this.windowWidth = document.documentElement.clientWidth;
    if (this.windowWidth >= 731) {
      if (this.parentRefs[this.code + "qty"]) {
        this.parentRefs[this.code + "qty"].hide();
      }
    }
  }

  onClassChange(className) {
    const classList = className.split(" ");
    if (classList.includes("sc-selected") && this.windowWidth < 731) {
      if (this.parentRefs[this.code + "qty"]) {
        this.parentRefs[this.code + "qty"].show();
      }
    } else {
      if (this.parentRefs[this.code + "qty"]) {
        this.parentRefs[this.code + "qty"].hide();
      }
    }
  }

  get nr_items() {
    return this.cart.countByCode(this.code);
  }

  @Watch("nr_items")
  onNrItemsChange() {
    let el = this.$refs["cat"] as any;
    if (el) {
      if (this.nr_items > 0) {
        el.classList.add("mobileaddedtocart");
      } else {
        el.classList.remove("mobileaddedtocart");
      }
    }
  }
}
